<div
  class="mode-notebook-cell"
  (click)="handleEditorClick($event)"
  [ngClass]="{
    'with-markdown': (isMarkdownViewMode$ | async),
    'editing': (isEditing$ | async),
    'mode-notebook-cell-folded': cell?.folded ?? false
  }">
  <div class="mode-notebook-cell-header"
    *ngIf="cell?.content_type === 'python'">
    <capra-icon icon="icon-refresh" *ngIf="cell?.executing"></capra-icon>
    <div
      *ngIf="!cell?.executing && cell?.frozen"
      class="mode-notebook-icon-status align-md-icon icon-freeze-gray"
      title="This cell is frozen and will not run unless it is unfrozen"
      capraTooltip
      tooltipContent="This cell is frozen and will not run unless it is unfrozen"
      tooltipPlacement="bottom"
      tooltipClass="wrapping-tooltip"
      [tooltipDisable]="!cell.frozen"></div>
    IN {{ executionCount$ | async }}
    <mode-state-indicator-icon
      *ngIf="showInLayout"
      [displayStateIcon]="true"
      mainIcon="icon-cell"
      tooltipPlacement="bottom"
      stateIcon="icon-check"
      tooltipHtmlContent="This cell is included in the report"
      class="notebook-cell-state-indicator --input-cell"
      data-test="notebook-cell-state-indicator"></mode-state-indicator-icon>
  </div>
  <div class="mode-notebook-cell-label">{{ typeAbbr$ | async }}</div>
  <div class="mode-notebook-editor-cell"
    [ngClass]="{'mode-notebook-cell-frozen': cell?.frozen}">

    <!-- Notebook Viewer -->
    <mode-code-highlight
      *ngIf="readOnly && cell?.content_type === 'python'"
      [lang]="lang$ | async"
      [lineNumbers]="true"
      [code]="cell?.content"></mode-code-highlight>

    <!-- Notebook Editor -->
    <mode-notebook-cell-ace
      *ngIf="!readOnly && !(isMarkdownViewMode$ | async)"
      [lang]="lang$ | async"
      [(ngModel)]="cellContent"
      [session]="session"
      [controlEvents]="aceControls"
      [readOnly]="cell?.frozen"
      [secretKeys]="secretKeys$ | async"
      [cellToken]="cell?.token"
      (onTextChanged)="handleTextChanged($event)"></mode-notebook-cell-ace>

    <!-- Markdown Viewer -->
    <mode-notebook-cell-markdown
      *ngIf="isMarkdownViewMode$ | async"
      (dblclick)="!readOnly && editMarkdown()"
      [markdown]="markdownText"></mode-notebook-cell-markdown>
  </div>
</div>